export default __webpack_public_path__ + "static/media/noise-opaque.0e648341.png";